<template>
  <div>
    <div class="center"> <h1>Purchase Complete!</h1> </div>
    <div class="center">
      <router-link :to="{ name: 'userhome' }"> Back home </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      email: null,
      username: null,
    };
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$store.state.email == null) {
        vm.$router.push({ name: "login" });
      } else {
        vm.email = vm.$store.state.email;
      }
    });
  },

  mounted() {
    this.refreshUserCoins();
  },

  methods: {
    async refreshUserCoins() {
      try {
        const response = await fetch('/GetUserCoins/', { credentials: 'include' });
        const data = await response.json();
        if (data.error === 0) {
          this.$store.commit('setUserCoins', data.result || 0);
        }
      } catch (e) {
        console.error('Failed to refresh coins after purchase:', e);
      }
    },
  },
};
</script>

<style scoped>
.center {
  text-align: center;
  vertical-align: middle;
  line-height: 12;
  padding: 2rem;
}
</style>
